import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext';


const AdminRoute = () => {
 
    const { user,loading } = useAuth(); 

  if (loading) {
    
    return <div>Loading...</div>;
  }


  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return user.role === "admin" ? <Outlet /> : <Navigate to="/unauthorized" replace />;
}

export default AdminRoute
